import {RouteContext} from "./RouteContext";
import {useEffect} from "react";
import {getCurrentSubDomain} from "../HomePage";

export default function HomePage(props: RouteContext) {

    const currentSubDomain = getCurrentSubDomain();

    useEffect(()=>{
        document.title = currentSubDomain + ' 관리자 페이지';
    },[])

    return <>홈</>
}